//@flow
import React, { Component } from 'react';
import { MODIFIED, NOCHANGE, SYNCED, UPTODATE_NEEDED_ICON } from '../util/Constants';
import './AssetPropertyView.css';
import { ThemeSetup } from '../themes/ThemeSetup';
import { RepoItem } from '../autogenerated/ZoomBridge';
import FileInfoUtil from '../util/FileInfoUtil';
import t from '../i18n/I18n';
//import Portal from './Portal';
import ThumbnailUtil, { asyncCallForGetUserName } from '../util/ThumbnailUtil';
import { getNonAliveStatus, isNonAliveAsset, getContextMenuStatus } from '../util/SelectedItemUtil';
import DateTimeUtil from '../util/DateTimeUtil';
import { TextWithEllipsisFileExtension, TextWithEllipsisPathTruncate } from './TextWithEllipsis';
import System from '../basic/System';
import Portal from './Portal';
import { getInnerWidth, isMobileDevice } from '../util/ScreenUtil';
import ViewUtil from '../ViewUtil';
const debounceToolTip = _.debounce(getToolTipPosition, 500);
type AssetStatusViewProps = {
  mtime: string,
  asset: RepoItem,
  isNextLine: ?boolean,
  isContextMenu: ?boolean,
  contextMenuStatus: ?Object,
  status: ?string
};

export class AssetStatusView extends Component<Props, State> {
  componentDidMount() {
    asyncCallForGetUserName(this.props.asset.getAuthor());
  }

  componentDidUpdate(prevProps) {
    if (System.isDesktop()) {
      if (2 !== prevProps.asset.RENDER_STATUS && 2 === prevProps.asset.WC_STATUS_QUERY) {
        prevProps.asset.RENDER_STATUS = 2;
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (System.isDesktop()) {
      if (this.props.asset !== nextProps.asset) return true;
      if (
        (2 === nextProps.asset.WC_STATUS_QUERY && 2 === nextProps.asset.RENDER_STATUS) ||
        2 !== nextProps.asset.WC_STATUS_QUERY
      ) {
        return false;
      }
    }
    return true;
  }

  render() {
    const { props } = this;
    let mtime = props.mtime ? props.mtime : undefined;
    const isContextMenu = props.isContextMenu;
    const asset = props.asset;
    if (!mtime) {
      const formattedTime = DateTimeUtil.getFormattedTime(asset);
      mtime = formattedTime ? formattedTime.relative : '';
    }
    const userName = ThumbnailUtil.getFullNameFromCache(asset.getAuthor());
    // asyncCallForGetUserName(asset.getAuthor());
    const statusObject = asset.wcStatusObject;

    let wcModTime;
    let status;
    let nonAliveStatus = undefined;
    const itemAction = getNonAliveStatus(asset);
    if (statusObject && System.isDesktop()) {
      wcModTime = statusObject.getModTime() ? statusObject.getModTime() : mtime;
      status = props.status ? props.status : statusObject._wcStatus;
      /*if (status === POTENTIAL_CONFLICT) {
        status = UPTODATE_NEEDED_ICON;
      } else*/
      if (!isContextMenu && isNonAliveAsset(asset)) {
        nonAliveStatus = itemAction;
        wcModTime = mtime;
      }
      let menuStatus;
      let nextLine = undefined;
      if (isContextMenu) {
        let contextMenuStatus = props.contextMenuStatus
          ? props.contextMenuStatus
          : getContextMenuStatus(status, wcModTime);
        if (contextMenuStatus) {
          menuStatus = contextMenuStatus.menuStatus;
          nextLine = contextMenuStatus.modStat
            ? contextMenuStatus.modStat
            : itemAction
            ? userName + ' ' + itemAction.toLowerCase() + ' ' + mtime
            : null;
        }
      } else {
        menuStatus = nonAliveStatus ? nonAliveStatus : status === NOCHANGE ? t(MODIFIED) : t(status);
        nextLine = props.isNextLine ? userName + wcModTime : undefined;
      }
      if (FileInfoUtil.isFolder(asset)) {
        return (
          <div name="AssetPropertyView" className="pl" style={props.view === 'list' ? { display: 'flex' } : {}}>
            {props.view === 'list' ? (
              <div>
                <span
                  style={status === 'CONFLICT' ? { marginLeft: 2 } : {}}
                  className={status ? status + '-FOLDER' : SYNCED + '-FOLDER'}></span>
              </div>
            ) : (
              <React.Fragment>
                <span
                  className={status ? status + '-FOLDER' : SYNCED + '-FOLDER'}
                  style={props.view === 'grid' ? { margin: 'auto 5px 4px auto' } : null}></span>
                {props.view !== 'grid' ? t(menuStatus) : null}
              </React.Fragment>
            )}

            {props.isNextLine ? (
              <div className="mtimeWithStatus">{nextLine}</div>
            ) : props.view === 'list' ? (
              <div style={{ flexBasis: '100%', overflow: 'hidden' }}>
                <TextWithEllipsisFileExtension
                  text={t(menuStatus) + ' ' + wcModTime}
                  title={t(menuStatus) + ' ' + wcModTime}
                  wrap={true}
                  style={{
                    display: 'inline-block',
                    fontSize: 12,
                    paddingLeft: 2,
                    color: 'unset'
                  }}></TextWithEllipsisFileExtension>
              </div>
            ) : props.view === 'grid' ? (
              <TextWithEllipsisFileExtension
                text={t(menuStatus) + ' ' + wcModTime}
                title={t(menuStatus) + ' ' + wcModTime}
                wrap={true}
                style={{
                  display: 'inline-block',
                  fontSize: 'unset',
                  color: 'unset'
                }}></TextWithEllipsisFileExtension>
            ) : (
              ' ' + wcModTime
            )}
          </div>
        );
      } else {
        return (
          <div
            name="AssetPropertyView"
            className="pl"
            style={props.view === 'list' ? { display: 'flex' } : props.view === 'grid' ? null : { paddingLeft: '5px' }}>
            {props.view === 'list' ? (
              <div>
                <span className={status ? (props.isContextMenu ? status + ' isMenu' : status) : SYNCED}>
                  <UpdateStatusIcon status={status} isMenu={props.isContextMenu} />
                </span>
              </div>
            ) : (
              <React.Fragment>
                <span
                  className={status ? (props.isContextMenu ? status + ' isMenu' : status) : SYNCED}
                  style={props.view === 'grid' ? { margin: 'auto 5px 4px auto' } : null}>
                  <UpdateStatusIcon status={status} isMenu={props.isContextMenu} />
                </span>
                {props.view !== 'grid' ? menuStatus : null}
              </React.Fragment>
            )}

            {props.isNextLine ? (
              <div className="mtimeWithStatus">{nextLine}</div>
            ) : props.view === 'list' ? (
              <div style={{ flexBasis: '100%', overflow: 'hidden' }}>
                <TextWithEllipsisFileExtension
                  text={menuStatus + ' ' + wcModTime}
                  title={menuStatus + ' ' + wcModTime}
                  wrap={true}
                  style={{
                    display: 'inline-block',
                    fontSize: 12,
                    paddingLeft: 2,
                    color: 'unset'
                  }}></TextWithEllipsisFileExtension>
              </div>
            ) : props.view === 'grid' ? (
              <TextWithEllipsisFileExtension
                text={menuStatus + ' ' + wcModTime}
                title={menuStatus + ' ' + wcModTime}
                wrap={true}
                style={{
                  display: 'inline-block',
                  fontSize: 'unset',
                  color: 'unset'
                }}></TextWithEllipsisFileExtension>
            ) : (
              ' ' + wcModTime
            )}
          </div>
        );
      }
    }
    if (props.isContextMenu) {
      return props.view === 'list' ? (
        <TextWithEllipsisFileExtension
          text={itemAction ? userName + ' ' + itemAction.toLowerCase() + ' ' + mtime : ''}
          title={itemAction ? userName + ' ' + itemAction.toLowerCase() + ' ' + mtime : ''}
          wrap={true}
          noTooltip={true}
          style={{
            display: 'inline-block',
            fontSize: 12,
            position: 'absolute',
            color: 'unset'
          }}></TextWithEllipsisFileExtension>
      ) : (
        <span className="pl" title={itemAction ? userName + ' ' + itemAction.toLowerCase() + ' ' + mtime : ''}>
          {itemAction ? userName + ' ' + itemAction.toLowerCase() + ' ' + mtime : ''}
        </span>
      );
    } else {
      return props.view === 'list' ? (
        <div style={{ display: 'flex' }}>
          <div>
            <span className={itemAction ? itemAction : null}></span>
          </div>
          <div style={{ flexBasis: '100%', overflow: 'hidden' }}>
            <TextWithEllipsisFileExtension
              text={itemAction ? ' ' + itemAction + ' ' + mtime : ''}
              title={itemAction ? ' ' + itemAction + ' ' + mtime : ''}
              wrap={true}
              style={{
                display: 'inline-block',
                fontSize: 12,
                position: 'absolute',
                color: 'unset'
              }}></TextWithEllipsisFileExtension>
          </div>
        </div>
      ) : (
        <div
          className="pl"
          title={itemAction ? ' ' + itemAction + ' ' + mtime : ''}
          style={props.view === 'grid' ? undefined : { paddingLeft: '5px' }}>
          <span className={itemAction ? itemAction.toUpperCase() : ''}></span>

          {props.view === 'grid' ? (
            <TextWithEllipsisFileExtension
              text={itemAction ? itemAction + ' ' + mtime : ''}
              title={itemAction ? itemAction + ' ' + mtime : ''}
              wrap={true}
              style={{
                display: 'inline-block',
                fontSize: 'unset',
                color: 'unset'
              }}></TextWithEllipsisFileExtension>
          ) : itemAction ? (
            itemAction + ' ' + mtime
          ) : (
            ''
          )}
        </div>
      );
    }
  }
}

export const AssetStatusTreeView = function(props: AssetStatusViewProps) {
  const asset = props.asset;
  let icon = null;
  const statusObject = asset.wcStatusObject;
  const itemAction = getNonAliveStatus(asset);
  if (System.isDesktop()) {
    if (statusObject) {
      let status = statusObject.getWcStatus();
      icon = status ? <span className={status + '-FOLDER'} /> : null;
    } else {
      let status = itemAction ? itemAction.toUpperCase() : null;
      icon = status ? <span className={status + '-FOLDER'} /> : null;
    }
  }
  return icon;
};

type AssetStatusListViewProps = {
  asset: RepoItem,
  mtime: string
};

export const AssetStatusListView = function(props: AssetStatusListViewProps) {
  const asset = props.asset;
  if (asset) {
    const extInfo = asset.extraInfo;
    return (
      <div style={{ position: 'relative', lineHeight: '51px' }}>
        {props.view === 'list' ? null : (
          <React.Fragment>
            <ProxyStatus
              onLeave={props.onLeave}
              onEnter={props.onEnter}
              isConnected={extInfo && extInfo.isIsConnected()}
              isProxy={asset.isProxy()}
            />
            <SmartLink
              isSmartLink={asset.isIsSmartLink()}
              isSmartCopy={asset.isIsSmartCopy()}
              smartCopySrc={asset.isIsSmartLink() ? asset.getSmartShareSrcPath() : asset.getSmartCopySrcPath()}
              smartCopySrcFrn={asset.getSmartCopySrcFrn()}
              srcFuid={asset.getSmartCopySrcFuid()}
              hoveredAsset={props.hoveredAsset}
              readOnly={asset.isReadOnlySmartShare()}
            />
          </React.Fragment>
        )}

        <AssetStatusView asset={asset} mtime={props.mtime} view={props.view} />
      </div>
    );
  }
  return null;
};

type AssetStateViewProps = {
  isSmartLink: boolean,
  isConnected: boolean,
  isSmartCopy: boolean,
  isProxy: boolean,
  asset: RepoItem
};

/**
 * @return {null}
 */
export const AssetStateView = function(props: AssetStateViewProps) {
  const asset: RepoItem = props.asset;
  if (asset) {
    const extInfo = asset.extraInfo;
    return (
      <div name="AssetStateView">
        {System.isVAB() ? (
          <ProxyStatus
            onLeave={props.onLeave}
            onEnter={props.onEnter}
            onIconClick={props.onIconClick}
            isConnected={extInfo && extInfo.isIsConnected()}
            isProxy={asset.isProxy()}
            dragPath={extInfo ? (extInfo._dragPath ? extInfo._dragPath : extInfo._expectedTPMPath) : null}
          />
        ) : null}
        <SmartLink
          isSmartLink={asset.isIsSmartLink()}
          isSmartCopy={asset.isIsSmartCopy()}
          smartCopySrc={asset.isIsSmartLink() ? asset.getSmartShareSrcPath() : asset.getSmartCopySrcPath()}
          smartCopySrcFrn={asset.getSmartCopySrcFrn()}
          readOnly={asset.isReadOnlySmartShare()}
          srcFuid={asset.getSmartCopySrcFuid()}
        />
      </div>
    );
  }
  return null;
};

/**
 * @return {null}
 */
type ProxyProps = {
  isConnected: boolean,
  isProxy: boolean,
  dragPath: string,
  style: object
};
export const ProxyStatusList = function(props: ProxyProps) {
  const isConnected = props.isConnected;
  const isProxy = props.isProxy;
  const textStyle = {
    color: 'unset',
    fontSize: 12,
    position: 'relative',
    top: 14,
    width: 'calc(100% - 18px - 2px)',
    marginLeft: 2
  };
  const dragPath = props.dragPath;
  //const truncatedDragPath = dragPath ? TextWithEllipsisPathTruncate.getTruncatedPath(dragPath) : dragPath;
  const truncatedDragPath = dragPath;
  return isConnected ? (
    props.highLight ? (
      <React.Fragment>
        <ToolTip text={t('CONNECTED_PATH', { DRAG_PATH: truncatedDragPath })}>
          <div
            className="proxyStatus"
            style={props.style}
            onClick={(e: MouseEvent) => props.onIconClick(e, dragPath)}
            onMouseLeave={props.onLeave}
            onMouseEnter={props.onEnter}>
            <center>
              <img src={'images/ConnectedDark.svg'} />
            </center>
          </div>
        </ToolTip>
        <TextWithEllipsisFileExtension
          text={dragPath}
          title={truncatedDragPath}
          style={textStyle}></TextWithEllipsisFileExtension>
      </React.Fragment>
    ) : (
      <React.Fragment>
        <ToolTip text={t('CONNECTED_PATH', { DRAG_PATH: truncatedDragPath })}>
          <div
            className="proxyStatus"
            style={props.style}
            onClick={(e: MouseEvent) => props.onIconClick(e, dragPath)}
            onMouseLeave={props.onLeave}
            onMouseEnter={props.onEnter}>
            <center>
              <img src={ThemeSetup.getImageURL('ConnectedLight.svg')} />
            </center>
          </div>
        </ToolTip>
        <TextWithEllipsisFileExtension
          text={dragPath}
          title={truncatedDragPath}
          style={textStyle}></TextWithEllipsisFileExtension>
      </React.Fragment>
    )
  ) : isProxy ? (
    props.highLight ? (
      <React.Fragment>
        <ToolTip text={!dragPath ? t('DISCONNECTED') : t('DISCONNECTED_PATH', { DRAG_PATH: truncatedDragPath })}>
          <div className="proxyStatus" style={props.style} onMouseLeave={props.onLeave} onMouseEnter={props.onEnter}>
            <center>
              <img src={'images/DisconnectedDark.svg'} />
            </center>
          </div>
        </ToolTip>
        <TextWithEllipsisFileExtension
          text={dragPath}
          title={truncatedDragPath}
          style={textStyle}></TextWithEllipsisFileExtension>
      </React.Fragment>
    ) : (
      <React.Fragment>
        <ToolTip text={!dragPath ? t('DISCONNECTED') : t('DISCONNECTED_PATH', { DRAG_PATH: truncatedDragPath })}>
          <div className="proxyStatus" style={props.style} onMouseLeave={props.onLeave} onMouseEnter={props.onEnter}>
            <center>
              <img src={ThemeSetup.getImageURL('DisconnectedLight.svg')} />
            </center>
          </div>
        </ToolTip>
        <TextWithEllipsisFileExtension
          text={dragPath}
          title={truncatedDragPath}
          style={textStyle}></TextWithEllipsisFileExtension>
      </React.Fragment>
    )
  ) : (
    <div style={props.style}>-</div>
  );
};

export const ProxyStatus = function(props) {
  const isConnected = props.isConnected;
  const isProxy = props.isProxy;
  const dragPath = props.dragPath;
  //const truncatedDragPath = dragPath ? TextWithEllipsisPathTruncate.getTruncatedPath(dragPath) : dragPath;
  const truncatedDragPath = dragPath;
  return isConnected ? (
    <ToolTip text={t('CONNECTED_PATH', { DRAG_PATH: truncatedDragPath })}>
      <div
        className="proxyStatus"
        style={props.style ? props.style : null}
        onMouseLeave={props.onLeave}
        onMouseEnter={props.onEnter}
        onClick={(e: MouseEvent) => props.onIconClick(e, dragPath)}>
        <center>{<img src="images/Connected.svg"></img>}</center>
      </div>
    </ToolTip>
  ) : isProxy ? (
    <ToolTip text={!dragPath ? t('DISCONNECTED') : t('DISCONNECTED_PATH', { DRAG_PATH: truncatedDragPath })}>
      <div
        className="proxyStatus"
        style={props.style ? props.style : null}
        onMouseLeave={props.onLeave}
        onMouseEnter={props.onEnter}>
        <center>{<img src="images/Disconnected.svg"></img>}</center>
      </div>
    </ToolTip>
  ) : null;
};

/**
 * @return {null}
 */
export const SmartLink = function(props) {
  const isSmartLink = props.isSmartLink;
  const isSmartCopy = props.isSmartCopy;
  //const hoveredAsset = props.hoveredAsset;
  const style = props.style;
  return isSmartLink ? (
    <div style={{ display: 'inline-block' }}>
      <ToolTip
        text={t('SMART_LINK_TIP', {
          READ_WRITE: props.readOnly ? 'Readable' : 'Writable',
          SRC_FILE: props.smartCopySrc
        })}>
        <div
          className="smartlink"
          style={style}
          onClick={(e: MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
            ViewUtil.switchToAssetDetailView(props.srcFuid, true);
          }}>
          <img src="images/smartLink.svg" />
        </div>
      </ToolTip>
    </div>
  ) : isSmartCopy ? (
    <div style={{ display: 'inline-block' }}>
      <ToolTip text={t('SMART_COPY_TIP', { SRC_FILE: props.smartCopySrc, REVISION_NUM: props.smartCopySrcFrn })}>
        <div
          className="smartlink"
          style={style}
          onClick={(e: MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
            ViewUtil.switchToAssetDetailView(props.srcFuid, true);
          }}>
          <img src="images/smartCopy.svg" />
        </div>
      </ToolTip>
    </div>
  ) : null;
};

export const SmartLinkCopy = function(props) {
  const { isSmartLink, isSmartCopy, style, hoveredAsset, isSelected } = props;
  const smartStyle = {
    display: 'inline',
    marginLeft: 4,
    fontSize: 12
  };
  return isSmartLink ? (
    <ToolTip
      text={t('SMART_LINK_TIP', {
        READ_WRITE: props.readOnly ? 'Readable' : 'Writable',
        SRC_FILE: props.smartCopySrc
      })}
      style={style}>
      <div
        className="smartlink"
        style={{ display: 'flex' }}
        onClick={(e: MouseEvent) => {
          e.preventDefault();
          e.stopPropagation();
          ViewUtil.switchToAssetDetailView(props.srcFuid, true);
        }}>
        <div>
          <img
            src={
              hoveredAsset || isSelected
                ? ThemeSetup.getImageURL('smartLinkDark.svg')
                : ThemeSetup.getImageURL('smartLink.svg')
            }
          />
        </div>
        <div style={smartStyle} style={{ flexBasis: '100%', overflow: 'hidden' }}>
          <TextWithEllipsisFileExtension
            text={t('SMART_LINK')}
            title={t('SMART_LINK')}
            style={{ color: 'unset', fontSize: 12 }}></TextWithEllipsisFileExtension>
        </div>
      </div>
    </ToolTip>
  ) : isSmartCopy ? (
    <ToolTip
      text={t('SMART_COPY_TIP', { SRC_FILE: props.smartCopySrc, REVISION_NUM: props.smartCopySrcFrn })}
      style={style}>
      <div
        className="smartlink"
        style={{ display: 'flex' }}
        onClick={(e: MouseEvent) => {
          e.preventDefault();
          e.stopPropagation();
          ViewUtil.switchToAssetDetailView(props.srcFuid, true);
        }}>
        <div>
          <img
            src={
              hoveredAsset || isSelected
                ? ThemeSetup.getImageURL('smartCopyDark.svg')
                : ThemeSetup.getImageURL('smartCopy.svg')
            }
          />
        </div>
        <div style={smartStyle} style={{ flexBasis: '100%', overflow: 'hidden' }}>
          <TextWithEllipsisFileExtension
            text={t('SMART_COPY')}
            title={t('SMART_COPY')}
            style={{ color: 'unset', fontSize: 12 }}></TextWithEllipsisFileExtension>
        </div>
      </div>
    </ToolTip>
  ) : (
    <div>
      <span style={style}>-</span>
    </div>
  );
};

type AssetStateWithNameProps = {
  isLock: boolean,
  assetType: string,
  asset: RepoItem,
  style?: object
};

export const AssetStateWithName = function(props: AssetStateWithNameProps) {
  const asset = props.asset;
  let isLocked: boolean = false;
  let lockTip = undefined;
  const isHovered = props.isHovered;
  if (asset) {
    isLocked = asset.isIsLocked();
    lockTip = t('LOCKED_BY_ON', { USER: asset.getLockOwner(), TIME: asset.getLockTime() });
  }
  return (
    <div name="AssetStateWithName" className="col" style={props.style ? props.style : null}>
      {/*System.isVAB() */ true ? (
        <React.Fragment>
          {isLocked ? <LockStatus lockTip={lockTip} /> : null}
          {!FileInfoUtil.isFolder(asset) ? (
            <AssetIcon
              assetType={asset.getBasicFileAttributes().getMediaType()}
              iconPath={asset.getBasicFileAttributes().getFileIcon()}
              isHovered={isHovered}
              isSeq={asset.isImageSeq()}
            />
          ) : null}
        </React.Fragment>
      ) : null}
      {props.children}
    </div>
  );
};

const LockStatus = function(props) {
  return (
    <ToolTip text={props.lockTip} style={{ display: 'inline-block' }}>
      <div className="lockStatus">
        <img src={ThemeSetup.getImageURL('Icon_Lock_Filled.svg')} />
      </div>
    </ToolTip>
  );
};

const AssetIcon = function(props) {
  return (
    <div className="assetIcon" style={{ display: 'inline-block', marginRight: '5px' }}>
      {props.iconPath ? (
        <img src={props.iconPath} />
      ) : props.assetType == 'IMAGE' ? (
        <GetImageIcon isHovered={props.isHovered} isSeq={props.isSeq} />
      ) : props.assetType == 'VIDEO' ? (
        <GetVideoIcon isHovered={props.isHovered} />
      ) : props.assetType == 'AUDIO' ? (
        <GetAudioIcon />
      ) : null}
    </div>
    //  </ToolTip>
  );
};

const GetAudioIcon = function(props) {
  const audioIcon = 'images/audio.png';
  return <img src={audioIcon} />;
};

const GetVideoIcon = function(props) {
  const videoIcon = ThemeSetup.getImageURL('icon_video_file.svg');
  const videoIconHover = ThemeSetup.getImageURL('icon_video_file_hover.svg');
  return <img src={props.isHovered ? videoIconHover : videoIcon} />;
};

const GetImageIcon = function(props) {
  const seqImgPath = ThemeSetup.getImageURL('icon_image_seq.svg');
  const seqImgPathHover = ThemeSetup.getImageURL('icon_image_seq_hover.svg');
  if (props.isSeq) {
    return <img src={props.isHovered ? seqImgPathHover : seqImgPath} />;
  } else {
    return <i className="fa fa-image"></i>;
  }
};

type UpdateStatusIconProps = {
  status: string,
  isMenu: boolean
};

/**
 * @return {null}
 */
const UpdateStatusIcon = function(props: UpdateStatusIconProps) {
  let icon = null;
  if ((props.status === UPTODATE_NEEDED_ICON || (props.status === MODIFIED && props.isMenu)) && props.isMenu) {
    icon = (
      <img
        className="UPDATE_DOWN"
        src={props.status === UPTODATE_NEEDED_ICON ? 'images/downArrow.svg' : 'images/up-arrow.svg'}
      />
    );
  }
  return icon;
};

type ToolTipProps = {
  text: string,
  style?: object
};

type ToolTipState = {
  show: boolean
};
export default class ToolTip extends React.Component<ToolTipProps, ToolTipState> {
  timeOut: function = null;

  constructor(props) {
    super(props);
    // this.toolTipRef = React.createRef();
    this.state = {
      show: false
    };
  }

  componentWillUnmount() {
    clearTimeout(this.timeOut);
  }

  showToolTip = (e: MouseEvent) => {
    const { text } = this.props;
    const target = e.target;
    const x = e.clientX;
    const waitTime = this.props.customToolTip ? 500 : 1500;
    const textValue = text !== '-' && text ? true : false;
    if (textValue || this.props.customToolTip)
      this.timeOut = setTimeout(() => {
        this.setState({ show: true }, () => {
          getToolTipPosition(x, target);
        });
      }, waitTime);
  };

  hideToolTip = () => {
    clearTimeout(this.timeOut);
    this.setState({ show: false });
  };

  onMouseMove = (e: MouseEvent) => {
    const { show } = this.state;
    if (show) {
      debounceToolTip(e.clientX, e.target);
    }
  };

  render() {
    const { show } = this.state;
    const tooltipScreenMargin = isMobileDevice() ? 10 : 350;
    return (
      <React.Fragment>
        {show ? (
          <Portal defaultOpen={true}>
            <div
              className="Tooltip"
              id="activeToolTip"
              style={{
                maxWidth: this.props.maxWidth ? `${this.props.maxWidth}px` : getInnerWidth() - tooltipScreenMargin,
                wordBreak: this.props.wordBreak ?? 'break-word',
                zIndex: 9999
              }}>
              {this.props.customToolTip ? this.props.customToolTip : this.props.text}
            </div>
          </Portal>
        ) : null}
        <div
          name="ToolTip"
          style={this.props.style ? this.props.style : null}
          onClick={this.props.customToolTip ? this.hideToolTip : _.noop}
          onMouseEnter={this.showToolTip}
          onMouseMove={this.onMouseMove}
          onMouseLeave={this.hideToolTip}>
          {this.props.children}
        </div>
      </React.Fragment>
    );
  }
}

function getToolTipPosition(clientX, tootltipRef) {
  const element = document.getElementById('activeToolTip');
  if (!element || !tootltipRef) return;
  const screenW = window.innerWidth;
  const screenH = window.innerHeight;
  const rootW =  element.offsetWidth+10;
  const rootH = element.offsetHeight;
  let child;
  let tooltipTop = 0,
    tooltipLeft = 0;

  if (tootltipRef) {
    if (tootltipRef.firstElementChild) child = tootltipRef.firstElementChild;
    else child = tootltipRef;
    const { height, width, top, left, bottom } = child.getBoundingClientRect();
    tooltipTop = top + height + 10;
    tooltipLeft = clientX + 20;
    if (tooltipTop + rootH > screenH) {
      tooltipTop = tooltipTop - rootH - height - 5;
    }
    let tLeft = tooltipLeft + rootW;
    if (tLeft > screenW) {
      // tooltipLeft = tooltipLeft - rootW;
      tooltipLeft = screenW - rootW;
      if (tooltipLeft < 0) {
        tooltipLeft = 0;
      }
    }
  }
  element.style.left = `${tooltipLeft}px`;
  element.style.top = `${tooltipTop}px`;
}
